module.exports = __webpack_public_path__ + "components/MapControl/svg/Krzyż_figura.svg?0c76563a";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Krzyż_figura.svg
// module id = 2015
// module chunks = 0